import __base_store from '@/store/__base_store'

/**
 * Store de plantillas online (modelo `online_template`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'online_template',
	},
})

